export const gcpStorageUrl =
  'https://storage.googleapis.com/antidote-public-assets/enrollment-app'

export const WEBSITE_URL = 'https://www.antidotehealth.com'
export const SUPPORT_LINK = 'https://www.antidotehealth.com/insurance/contact'
export const QUALIFICATION_LINK =
  'https://www.antidotehealth.com/blog/understanding-the-affordable-care-acts-enrollment-periods'
export const gcpStoragePlanFilesUrl = `${gcpStorageUrl}/plan-files`
export const gcpStoragePlanFilesUrl_2025 =
  'https://storage.googleapis.com/antidote-public-assets/dropbox'

export const BROKER_PORTAL_LINK =
  'https://antidote-health--qa.sandbox.my.site.com/broker/s/login/?language=en_US&ec=301&startURL=%2Fbroker%2Fs%2Fapplications'

export const IDLE_TIMEOUT = 5 // time from last interation until emit action (debaunce)
export const INACTIVITY_TIMEOUT_IN_SECONDS = 15 * 60 // time user was inactive
export const INACTIVITY_TIMEOUT_WARNING_IN_SECONDS = 2 * 60 // 2 minutes before timeout

export const COUNTRY_CODES =
  process.env.REACT_APP_ENV === 'prod' ? [1] : [1, 972]

export const dateFormat = 'M/D/YYYY'
export const BACKEND_DATE_FORMAT = 'YYYY-MM-DD'

export const relationship = {
  owner: 'owner',
  spouse: 'spouse',
  dependent: 'dependent'
}

export const relationshipToColor = {
  owner: '#8FBF29',
  spouse: '#48978B',
  dependent: '#6E7BF4'
}

export const languages = {
  english: 'english',
  spanish: 'spanish',
  arabic: 'arabic',
  bengali: 'bengali',
  chinese: 'chinese',
  farsi: 'farsi',
  french: 'french',
  german: 'german',
  haitian_creole: 'haitianCreole',
  hindi: 'hindi',
  italian: 'italian',
  japanese: 'japanese',
  korean: 'korean',
  navajo: 'navajo',
  polish: 'polish',
  portuguese: 'portuguese',
  russian: 'russian',
  tagalog: 'tagalog',
  thai: 'thai',
  vietnamese: 'vietnamese',
  yiddish: 'yiddish'
}

export const LAYOUT_TYPE = {
  broker: 'broker',
  self_enroll: 'self_enroll'
}

export const DIALOG_TYPE = {
  SHARE_APPLICATION: 'shareApplication',
  SAVE_PROGRESS: 'saveProgress'
}

export const SUPPORT_PHONE_NUMBER = '(888) 302-4123'
export const SUPPORT_PHONE_NUMBER_WITH_COUNTRY_CODE = `+1 ${SUPPORT_PHONE_NUMBER}`